import { fispqActions } from '../actions'

const {
  FETCHING_FISPQS,
  FETCH_FISPQS,
  FETCH_FISPQS_ERROR,
} = fispqActions

const initialState = {
  fetching: {
    fispqList: false,
  },
  canChangeStatus: true,
  fispqList: [],
  last_update: undefined,
  total_records: undefined,
  fetch_errors: {
    fispqList: false,
  }
}

const fispqs = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_FISPQS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          fispqList: action.value
        }
      }

    case FETCH_FISPQS:
      return {
        ...state,
        last_update: action.last_update,
        total_records: action.total_records,
        canChangeStatus: action.canChangeStatus,
        fispqList: action.items,
        pagination: action.pagination,
        fetching: {
          ...state.fetching,
          fispqList: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          fispqList: false
        }
      }


    case FETCH_FISPQS_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          fispqList: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          fispqList: true
        }
      }

    default:
      return state
  }
}

export default fispqs



// WEBPACK FOOTER //
// ./src/reducers/fispqs.js